ko.bindingHandlers.splitter = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

        let splitter = null;

        if (!('Split' in window)) { throw 'Splitter is not defined!' }

        const userOptions = {};

        Object.assign(userOptions, ko.bindingHandlers.splitter.defaultUserOptions);
        Object.assign(userOptions, ko.utils.unwrapObservable(valueAccessor()));

        const sizesObservable = ko.isObservable(userOptions.sizes) ?
            userOptions.sizes :
            null;


        userOptions.sizes = ko.unwrap(userOptions.sizes);

        const key = userOptions.key || 'splitter_' + ko.bindingHandlers.splitter.generateGUID();


        //fix if splitter has gone haywire (=sum of all panels != 100%)
        if (userOptions.sizes?.reduce((partialSum, a) => partialSum + a, 0) < 100) {
            const panesize = (100/userOptions.sizes.length ) //size of one pane
            userOptions.sizes = userOptions.sizes.map(i => panesize);
            if (sizesObservable) {
                sizesObservable(userOptions.sizes)
            }
            if (userOptions.useStore) {
                window.localStorage[key] = JSON.stringify(userOptions.sizes);
            }
        }


        const elements = [...element.children];

        element.classList.add('splitter-main');

        //_element.addClass('splitter-main')

        const defaultOptions = {
            gutterAlign: 'start',
            direction: 'horizontal',
            gutterSize: 7,
            elementStyle: function (dimension, size, gutterSize) {
                return {
                    'flex-basis': 'calc(' + size + '% - ' + gutterSize + 'px)',
                }
            },
            gutterStyle: function (dimension, gutterSize) {
                return {
                    'flex-basis': gutterSize + 'px',
                    'flex-shrink': 0
                }
            },
            onDragStart: function (sizes) {
                elements.forEach(pane => pane.classList.remove('drag-animation'));

            },
            onDrag: function () {
                if (sizesObservable) {
                    sizesObservable(splitter.getSizes());
                }

            },
            onDragEnd: function (sizes) {
                elements.forEach(pane => pane.classList.add('drag-animation'));


                if (userOptions.useStore) {
                    window.localStorage[key] = JSON.stringify(sizes);
                }
            }
        };

        if (userOptions.useStore) {
            try {
                userOptions.sizes =
                    JSON.parse(localStorage.getItem(key)) ||
                    userOptions.sizes;

            } catch (err) {
                console.warn(err);
                userOptions.sizes = undefined;
            }
        }

        if (sizesObservable) {
            sizesObservable(userOptions.sizes)
        }

        const options = Object.assign(
            defaultOptions,
            userOptions);

        elements.forEach(function (i, index) {
            i.id = key + '_' + index;

            i.classList.add('split')
            i.classList.add('drag-animation')
            i.classList.add('content')
            i.classList.add((options.direction === 'horizontal') ?
                'split-horizontal' :
                'split-vertical');
            return i
        });

        //_element.css('flex-direction', options.direction === 'vertical' ? 'column' : 'row');

        element.classList.add(options.direction === 'vertical' ? 'vertical' : 'horizontal');


        splitter = Split(
            elements.map(function (i) { return '#' + i.id }),
            options)

        if (sizesObservable) sizesObservable.subscribe((sizes) => {
            splitter.setSizes(sizes);

            if (userOptions.useStore) {
                window.localStorage[key] = JSON.stringify(sizes);
            }
        });
    },
    defaultUserOptions: {
        useStore: false,
        key: '',
        minSize: 0
    },
    generateGUID: () => {
        let
            d = new Date().getTime(),
            d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
        });
    }
};